import {HttpErrorResponse, HttpEvent, HttpHandler, HttpInterceptor, HttpRequest} from '@angular/common/http';
import {Injectable, Injector} from '@angular/core';
import {Observable, throwError} from 'rxjs';
import {catchError} from 'rxjs/operators';
import {FlamingoAuthService} from './flamingo-auth.service';

@Injectable()
export class FlamingoHttpInterceptor implements HttpInterceptor {

  constructor(private inj: Injector) {
  }

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    const authService = this.inj.get(FlamingoAuthService);
    const authHeader = authService.getToken();
    let newReq = req;
    if (authHeader) {
      newReq = req.clone({headers: req.headers.set('Authorization', 'Bearer ' + authHeader)});
    }
    return next.handle(newReq).pipe(
      catchError((error: HttpErrorResponse) => {
          if (error.status === 401) {
            authService.markUnauthorized();
          }
          return throwError(error);
        }
      ));
  }
}
